import React, {Component} from 'react';
import './AuthSignupScreen.css';
import ArrowLink from "../Common/ArrowLink";
import RmField from "../Forms/RmField";
import RmButton from "../Common/RmButton";
import AuthScreen from "./AuthScreen";
import axios from 'axios';
import ErrorMessage from "../Common/ErrorMessage";
import {Redirect} from 'react-router-dom';

export default class AuthSignupScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            attemptingSignup: false,
            email: "",
            password: "",
            name: "",
            errorMessage: null,
            redirecting: false,
            tosChecked: false
        };
    }

    handleButtonClick() {
        if (this.state.attemptingSignup) {
            return;
        }

        this.submitSignup(this.state.email, this.state.password);
    }

    handleNameChange(value) {
        this.setState({
            name: value,
            errorMessage: null
        });
    }

    handleEmailChange(value) {
        this.setState({
            email: value,
            errorMessage: null
        });
    }

    handlePasswordChange(value) {
        this.setState({
            password: value,
            errorMessage: null
        });
    }

    handleTosToggle(e) {
        this.setState({
            tosChecked: e.target.checked
        });
    }

    submitSignup() {
        this.setState({
            attemptingSignup: true,
            errorMessage: null
        });

        if (!this.state.tosChecked) {
            this.setState({
                attemptingSignup: false,
                errorMessage: "Je moet akkoord gaan met het privacybeleid om een account aan te maken."
            });

            return;
        }

        let payload = {
            name: this.state.name,
            email: this.state.email,
            password: this.state.password
        };

        axios.post("/signup", payload)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        redirecting: true
                    });
                } else {
                    this.setState({
                        errorMessage: data.message || "Controleer de ingevoerde gegegevens."
                    });
                }
            })
            .catch((err) => {
                console.error('Signup failure caught:', err);

                this.setState({
                    errorMessage: "Er ging iets mis bij het aanmelden. Probeer het opnieuw."
                });
            })
            .then(() => {
                this.setState({
                    attemptingSignup: false
                });
            });
    }

    render() {
        if (this.state.redirecting) {
            return <Redirect to='/'/>;
        }

        return (
            <AuthScreen title={"Aanmelden voor de planning tools"}>
                <p className={"AuthSignupScreen__intro"}>
                    Vul de onderstaande gegevens in om direct een account aan te maken voor de uitvaart <a href="https://www.rememberme.nl/planning-tools" target={"_blank"} title={"Meer informatie"}>planning tools van RememberMe</a>.
                </p>

                <div>
                    <RmField id={"name"} label={"Vul hier uw naam in..."} iconName={"account-outline"}
                             inputType={"text"} disabled={!!this.state.attemptingSignup}
                             value={this.state.name} onChange={this.handleNameChange.bind(this)}
                    />
                    <RmField id={"email"} label={"Vul hier uw e-mail adres in..."} iconName={"email-outline"}
                             inputType={"email"} disabled={!!this.state.attemptingSignup}
                             value={this.state.email} onChange={this.handleEmailChange.bind(this)}
                    />
                    <RmField id={"password"} label={"Vul hier uw wachtwoord in..."} iconName={"key-variant"}
                             inputType={"password"} disabled={!!this.state.attemptingSignup}
                             value={this.state.password} onChange={this.handlePasswordChange.bind(this)}
                    />
                </div>

                <p className={"AuthSignupScreen__tos"}>
                    <span>Op de planning tools is het <a href={"https://www.rememberme.nl/privacybeleid-rememberme-nl"}
                                                        target={"_blank"}>Privacybeleid RememberMe.nl</a> van toepassing.</span>

                    <input disabled={!!this.state.attemptingSignup} type={"checkbox"} id={"toscheck"}
                           checked={this.state.tosChecked} onChange={this.handleTosToggle.bind(this)}/>

                    <label htmlFor={"toscheck"}>Ja, ik heb kennis genomen van het privacybeleid van RememberMe.nl en geef uitdrukkelijk toestemming voor het verwerken van mijn persoonsgegevens om de planning tools te kunnen gebruiken.</label>

                    {/*<br />*/}
                    {/*Door een account aan te maken, geef je aan akkoord te gaan met de <a href={"https://www.rememberme.nl/algemene-voorwaarden-rememberme-nl-b2c"} target={"_blank"}>Algemene voorwaarden</a>.*/}
                </p>

                {this.state.errorMessage &&
                <ErrorMessage message={this.state.errorMessage}/>
                }

                <div className={"AuthSignupScreen__submit"}>
                    <RmButton label={"Registreren"} busy={!!this.state.attemptingSignup}
                              onClick={this.handleButtonClick.bind(this)}/>
                </div>

                <hr className={"AuthSignupScreen__sep"}/>

                <div className={"AuthSignupScreen__extras"}>
                    <ArrowLink label={"Ik heb al een account"} href={"/inloggen"}/>
                    <ArrowLink label={"Meer informatie over de planning tools"} href={"https://www.rememberme.nl/planning-tools"} target={"_blank"}/>
                </div>
            </AuthScreen>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Auth/AuthSignupScreen.js